<template>
  <div class="autocomplete-wrapper">
    <div class="autocomplete" v-if="filter === 'street'">
      <template v-for="(street) in autocomplete.getStreets" :key="street.id">
        <div class="autocomplete__suggestion">
          <button @click="$emit('update', street.street)">{{ street.street }}</button>
        </div>
      </template>
    </div>
    <div class="autocomplete" v-else>
      <template v-for="(city) in autocomplete.getCities" :key="city.id">
        <div class="autocomplete__suggestion">
          <button @click="$emit('update', city.city)">{{ city.city }}</button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { watch, toRef } from 'vue';
import { useAutocompleteStore } from '@/stores/autocomplete';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Autocomplete',
  props: {
    model: String,
    filter: String,
  },
  setup(props) {
    const autocomplete = useAutocompleteStore();
    const value = toRef(props, 'model');
    const filter = toRef(props, 'filter');
    function getUniqueList(term) {
      if (filter.value === 'street') {
        autocomplete.getUniqueStreets(term);
      } else if (filter.value === 'city') {
        autocomplete.getUniqueCities(term);
      }
    }
    watch(value, (currentValue) => {
      if (currentValue.length >= 3) {
        getUniqueList(currentValue);
      }
    });
    return {
      autocomplete,
      value,
    };
  },
};
</script>
